var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"fill-current inline-block",class:_vm.size?`w-${_vm.size} h-${_vm.size}`:`w-6 h-6`,attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20","fill":"currentColor"}},[_c('path',{attrs:{"d":"M5 4a2 2 0 012-2h6a2 2 0 012 2v14l-5-2.5L5 18V4z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }